import Vue from 'vue'
import {http} from '@/axios'
import router from '@/router'
import store from '@/store'

export default function respondOnAllBooked() {
  return http.post('/api/new-vacancy/bookmarks/mass-sent').then(({data}) => {
    if (!store.getters['user/isLogged']) {
      router.push({
        name: 'auth',
        query: {
          'for-mass-sent': 'true'
        }
      })
    } else {
      if (data.data.status === 'STATUS_SUCCESS') {
        router.push({
          name: 'account-my-vacancies',
          query: {
            showModalInfo: false // !isShownModalInfoResult ? 'true' : null
          }
        })
      } else if (data.data.status === 'STATUS_RESUME_FOUNT_ON_THIS_VACANCY') {
        Vue.prototype.$vModal.open('respond-on-vacancy-status', {
          status: data.data.status.status
        })
      } else {
        Vue.prototype.$vModal.open('after-respond-without-resume', {
          many: true,
          urls: data.data.status.urls
        })
      }
    }

    return data
  })
}
